import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import { useProductStore } from '../../../../ProductProvider';
import { IPageStatus } from '../../../../config/IPageStatus';
import { useEffect, useState } from 'react';
import { getSolarRecommand } from '@/service/solar-calculator';
import getLocal from '@/app/utils/i18n';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';

// 价格组件
const Price = ({ price, comparePrice }: { price: number; comparePrice?: number }) => {
    const { locale } = getLocal();
    return (
        <div className={styles.price}>
            {price && <div className="price">{FormatMoneyLocal(price, locale)}</div>}
            {comparePrice && comparePrice > price && <div className="comparePrice">{FormatMoneyLocal(comparePrice, locale)}</div>}
        </div>
    );
};

export default function Comp() {
    const { t } = useLang('theProduct.CompareA');
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();
    const IS_EU_SITE = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_NA_SITE = ['us', 'ca'].includes(locale);
    const IS_JP_SITE = ['jp'].includes(locale);

    const itemsA = [
        {
            subItems: [
                {
                    productId: (() => {
                        const productIds = {
                            us: 7414780887113,
                            ca: 15052470288755,
                            jp: 14692433330543,
                        };
                        return productIds[locale as 'us'] || productIds.us;
                    })(),
                    variantId: (() => {
                        const variantIds = {
                            us: 42093688913993,
                            ca: 52405166473587,
                            jp: 51841194393967,
                        };
                        return variantIds[locale as 'us'] || variantIds.us;
                    })(),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744770763317/35.png',
                    label: t('item_new'),
                    lChildren: IS_EU_SITE && pageStatus !== IPageStatus.statusA ? t('buy') : '',
                    title: t('item1_title'),
                    lDataLayer: IS_EU_SITE
                        ? {
                              event: 'uaEvent',
                              event_name: 'buy',
                              product_name: t('item1_title'),
                              position: t('title'),
                          }
                        : {
                              event: 'uaEvent',
                              event_name: 'checkout',
                              button_name: `${t('buy')}_${t('item1_title')}`,
                          },
                    specItems: [
                        {
                            title: t('item1_title1'),
                            desc: t('item1_desc1'),
                        },
                        {
                            title: t('item1_title2'),
                            desc: t('item1_desc2'),
                        },
                        {
                            title: t('item1_title3'),
                            desc: t('item1_desc3'),
                        },
                        {
                            title: t('item1_title4'),
                            desc: t('item1_desc4'),
                        },
                        {
                            title: t('item1_title5'),
                            desc: t('item1_desc5'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    productId: (() => {
                        const productIds = {
                            us: 7414780887113,
                            ca: 15052470288755,
                            jp: 14692433330543,
                        };
                        return productIds[locale as 'us'] || productIds.us;
                    })(),
                    variantId: (() => {
                        const variantIds = {
                            us: 42093688815689,
                            ca: 52405166408051,
                            jp: 51841192919407,
                        };
                        return variantIds[locale as 'us'] || variantIds.us;
                    })(),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744770763562/45.png',
                    lChildren: IS_EU_SITE && pageStatus !== IPageStatus.statusA ? t('buy') : '',
                    label: t('item_new'),
                    title: t('item2_title'),
                    lDataLayer: IS_EU_SITE
                        ? {
                              event: 'uaEvent',
                              event_name: 'buy',
                              product_name: t('item2_title'),
                              position: t('title'),
                          }
                        : {
                              event: 'uaEvent',
                              event_name: 'checkout',
                              button_name: `${t('buy')}_${t('item2_title')}`,
                          },
                    specItems: [
                        {
                            title: t('item2_title1'),
                            desc: t('item2_desc1'),
                        },
                        {
                            title: t('item2_title2'),
                            desc: t('item2_desc2'),
                        },
                        {
                            title: t('item2_title3'),
                            desc: t('item2_desc3'),
                        },
                        {
                            title: t('item2_title4'),
                            desc: t('item2_desc4'),
                        },
                        {
                            title: t('item2_title5'),
                            desc: t('item2_desc5'),
                        },
                    ],
                },
            ],
        },
        {
            subItems: [
                {
                    productId: (() => {
                        const productIds = {
                            us: 7414796615753,
                            ca: 15052472680819,
                            jp: 14692433330543,
                        };
                        return productIds[locale as 'us'] || productIds.us;
                    })(),
                    variantId: (() => {
                        const variantIds = {
                            us: 42093744685129,
                            ca: 52405173059955,
                            jp: 51841192952175,
                        };
                        return variantIds[locale as 'us'] || variantIds.us;
                    })(),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1744770763743/55.png',
                    lChildren: IS_EU_SITE && pageStatus !== IPageStatus.statusA ? t('buy') : '',
                    label: t('item_new'),
                    title: t('item3_title'),
                    lDataLayer: IS_EU_SITE
                        ? {
                              event: 'uaEvent',
                              event_name: 'buy',
                              product_name: t('item3_title'),
                              position: t('title'),
                          }
                        : {
                              event: 'uaEvent',
                              event_name: 'checkout',
                              button_name: `${t('buy')}_${t('item3_title')}`,
                          },
                    specItems: [
                        {
                            title: t('item3_title1'),
                            desc: t('item3_desc1'),
                        },
                        {
                            title: t('item3_title2'),
                            desc: t('item3_desc2'),
                        },
                        {
                            title: t('item3_title3'),
                            desc: t('item3_desc3'),
                        },
                        {
                            title: t('item3_title4'),
                            desc: t('item3_desc4'),
                        },
                        {
                            title: t('item3_title5'),
                            desc: t('item3_desc5'),
                        },
                    ],
                },
            ],
        },
    ].map((item) => ({
        subItems: [
            {
                ...item.subItems[0],
            },
        ],
    }));

    const [list, setList] = useState();
    useEffect(() => {
        if (IS_EU_SITE && pageStatus === 'statusA') {
            setList(itemsA as any);
            return;
        }
        const getAsynItem = async (productId: string, variantId: string) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = itemsA?.map((item: any) => getAsynItem(item?.subItems[0].productId, item.subItems[0].variantId));
        Promise.all(promises).then((res) => {
            const old = JSON.parse(JSON.stringify(itemsA));
            const list = res.map((i: any, idx) => {
                if (i.data.variantImg) {
                    old[idx].subItems[0].pc = i.data.variantImg;
                }
                // na 正式页面 jp 页面出现按钮价格
                if (IS_NA_SITE && pageStatus !== IPageStatus.statusA) {
                    old[idx].subItems[0].desc = <Price price={i.data.price} comparePrice={i.data.compareAtPrice} />;
                    old[idx].subItems[0].lChildren = t('buy');
                    old[idx].subItems[0].lHref = `https://${locale}.ecoflow.com/cart/${i.data.variantId}:1?channel=buy_button`;
                    old[idx].subItems[0].rChildren = t('more');
                    old[idx].subItems[0].rHref = `https://${locale}.ecoflow.com/products/${i.data.handle}`;
                } else if (IS_JP_SITE) {
                    old[idx].subItems[0].lChildren = t('buy');
                    old[idx].subItems[0].lHref = `https://jp.ecoflow.com/cart/${i.data.variantId}:1?channel=buy_button`;
                } else if (IS_EU_SITE) {
                    old[idx].subItems[0].lChildren = t('buy');
                    old[idx].subItems[0].lHref = `https://${locale}.ecoflow.com/products/glacier-classic-portable-fridge-freezer`;
                }
                return old[idx];
            });
            setList(list as any);
        });
    }, []);
    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            {list && <EcoCompareProduct items={list} />}
        </div>
    );
}
